import React, { Component } from 'react'
import QuicksightDashboard from './quicksightDashboardReport';
import CLIENT_QUICKSIGHT_URL from '../../config/config'
import CLIENT_QUICKSIGHT_UAT_URL from '../../config/configUat'
import AddTitleBar from "../../components/titleBar/add_titleBar";

export default class AwsReports extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dashboardToLoad: '',
      headerTitle: '',
      linkPath: ''
    };

    this.getDashboardID = this.getDashboardID.bind(this);
  }

  componentDidMount() {
    let title = this.props.location.search;
    let pathName = this.props.location.pathname;

    title = title.replace("?", "");
    title = title.split("_").join(" ");
    title = title.charAt(0) + title.substring(1).toLowerCase();

    this.setState({ headerTitle: title, linkPath: pathName });

    if (this.props && this.props?.history?.location?.search) {
      let temp = this.props.history.location?.search.replace('?', '')
      let dashboardURL = this.getDashboardID(temp);
      this.setState({ dashboardToLoad: dashboardURL }, () => {
        console.log(this.state.dashboardToLoad)
      });
    }
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps) {
    let title = this.props.location.search;
    let pathName = this.props.location.pathname;

    title = title.replace("?", "");
    title = title.split("_").join(" ");
    title = title.charAt(0) + title.substring(1).toLowerCase();

    if (this.props != prevProps && this.props?.history?.location?.search) {
      let temp = this.props.history.location?.search.replace('?', '')
      let dashboardURL = this.getDashboardID(temp);
      this.setState({ dashboardToLoad: dashboardURL, headerTitle: title, linkPath: pathName }, () => {
        console.log(this.state.dashboardToLoad)
      });
    }
  }

  getDashboardID(id) {
    switch (id) {
      case 'OFFER_VS_FINAL_PRICE':
        // code block
        return CLIENT_QUICKSIGHT_URL.OFFER_VS_FINAL_PRICE
        break;
      case 'ON_TIME_PLACEMENT_ANALYSIS':
        // code block
        return CLIENT_QUICKSIGHT_URL.ON_TIME_PLACEMENT_ANALYSIS
        break;
      case 'VENDOR_ALLOCATION_STATUS':
        // code block
        return CLIENT_QUICKSIGHT_URL.VENDOR_ALLOCATION_STATUS
        break;
      case 'PARTNER_PERFORMANCE_DASHBOARD':
        // code block
        return CLIENT_QUICKSIGHT_URL.PARTNER_PERFORMANCE_DASHBOARD
        break;
      case 'THC_DASHBOARD':
        // code block
        return CLIENT_QUICKSIGHT_URL.THC_DASHBOARD
        break;
      case 'TRIP_DISTANCE_ANALYSIS':
        // code block
        return CLIENT_QUICKSIGHT_URL.TRIP_DISTANCE_ANALYSIS
        break;
      case 'PERFORMANCE_EFFICIENCY':
        // code block
        return CLIENT_QUICKSIGHT_URL.PERFORMANCE_EFFICIENCY
        break;
      case 'USER_LOGIN_HISTORY':
        // code block
        return CLIENT_QUICKSIGHT_URL.USER_LOGIN_HISTORY
        break;
      case 'ORDERS_REPORT':
        // code block
        return CLIENT_QUICKSIGHT_URL.ORDERS_REPORT
        break;
      case 'DUMP_ANALYSIS':
        // code block
        return CLIENT_QUICKSIGHT_URL.DUMP_ANALYSIS
        break;
      case 'DAILY_PLACEMENT_DASHBOARD':
        // code block
        return CLIENT_QUICKSIGHT_URL.DAILY_PLACEMENT_DASHBOARD
        break;
      case 'MIS_REPORT':
        // code block
        return CLIENT_QUICKSIGHT_URL.MIS_REPORT
        break;
      case 'LR_DUMP_REPORT':
        // code block
        return CLIENT_QUICKSIGHT_URL.LR_DUMP_REPORT
        break;
      case 'DUMP_DASHBOARD':
          // code block
          return CLIENT_QUICKSIGHT_URL.DUMP_DASHBOARD
          break;
      case 'PLACEMENT_ANALYSIS':
        // code block
        return CLIENT_QUICKSIGHT_URL.PLACEMENT_ANALYSIS
        break;
      case 'LR_PROFITABILITY_REPORT':
        // code block
        return CLIENT_QUICKSIGHT_UAT_URL.LR_PROFITABILITY_REPORT
        break;
      case 'RATE_ENGINE_EXCEPTION_REPORT':
          // code block
          return CLIENT_QUICKSIGHT_URL.RATE_ENGINE_EXCEPTION_REPORT
          break;
      default:
      // code block
    }
  }



  render() {
    return (
      <React.Fragment>
        <div id="dispatch_bar">
          <AddTitleBar
            Title={this.state.headerTitle}
            LinkName="/new-order"
          />
        </div>
        <div className="p-2">
          {this.state.dashboardToLoad &&
            <QuicksightDashboard dashboardToLoad={this.state.dashboardToLoad} />
          }
        </div>
      </React.Fragment>
    )
  }
}
